/** Elapsed-duration readout for the workflow run card: `m:ss`, or
 *  `h:mm:ss` past the hour. */
export function formatElapsed(ms: number): string {
  const total = Math.max(0, Math.floor(ms / 1000));
  const s = total % 60;
  const m = Math.floor(total / 60) % 60;
  const h = Math.floor(total / 3600);
  const mm = h > 0 ? String(m).padStart(2, '0') : String(m);
  const hoursPrefix = h > 0 ? `${h}:` : '';
  return `${hoursPrefix}${mm}:${String(s).padStart(2, '0')}`;
}
